import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsOfUseComponent } from './terms-of-use.component';
import { SharedModule } from '../../shared/shared.module';
import { PrimeNGModule } from '../../shared/prime-ng.module';



@NgModule({
  declarations: [ TermsOfUseComponent ],
  imports: [
    CommonModule,
    SharedModule,
    PrimeNGModule
  ],
  exports: [
    TermsOfUseComponent
  ]
})
export class TermsOfUseModule { }
